export function isExternalLink(url: string): boolean {
    try {
        if (url.startsWith('/')) {
            return false;
        }
        if (/^[a-zA-Z][a-zA-Z\d+\-.]*:/.test(url)) {
            const linkUrl = new URL(url);
            const currentUrl = new URL(window.location.href);
            return linkUrl.origin !== currentUrl.origin;
        }
        return false;
    } catch {
        return false;
    }
}
